import React from "react";
import "./About.css";

const AboutUs = () => {
  return (
    <section className="about-section py-5" id="about">
      <div className="container">
        {/* gx-lg-5: Desktop gap | gy-5: Mobile gap */}
        <div className="row align-items-center gx-lg-5 gy-5">
          
          {/* Left Content Column */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="about-text-content">
              <h2 className="fw-bold text-light text-uppercase mb-3"> 
                <span className="gaubliisstext">Gaubliiss</span> <br /> 
                Organic Farm
              </h2>
              <div className="custom-divider mb-4"></div>
              
              <p className="text-light-custom">
                At <strong>Gaubliiss Organic Farm</strong>, we believe real prosperity begins with 
                community well-being. Our mission is to reconnect people with nature by 
                providing the purest and most nutritious farm-fresh products straight 
                from our eco-friendly and self-sustained farm.
              </p>
              
              <p className="text-light-custom">
                As a certified organic farm, we prioritize purity, sustainability, and integrity 
                in every drop of our <strong>100% pure A2 cow milk</strong>. Our cows graze on 
                chemical-free, naturally grown fodder, ensuring that you receive the best nutrition.
              </p>

              <p className="text-light-custom">
                Join us in our journey towards a <strong>healthier, happier community!</strong>
              </p>

              <a href="/#contact" className="btn btn-gold mt-4">
                Contact Us
              </a>
            </div>
          </div>

          {/* Right Image Column */}
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="about-img-wrapper">
              <img
                src="./gaublissBanner.jpeg"
                alt="Gaubliiss Organic Farm"
                className="about-img-main"
              />
              {/* Optional Design Element */}
              <div className="image-overlay-border"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutUs;